/**
 * Server-side analysis configuration
 *
 * After deploying to Modal.com, update the serverApiUrl below
 * with your actual endpoint URL.
 *
 * To deploy:
 * 1. cd server
 * 2. modal deploy modal_app.py
 * 3. Copy the URL from the output and paste it here
 */

// Set this to your Modal.com endpoint URL after deployment
// Example: 'https://your-username--music-theory-lab-chord-detector-detect-chords-api.modal.run'
export const SERVER_API_URL = 'https://agacinski--music-theory-lab-chord-detector-detect-chords-api.modal.run';

// Set to true to enable the server analysis option in the UI
export const SERVER_ENABLED = true;
